export default __webpack_public_path__ + "static/media/git.7d664489.png";